import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=1b37dc78&scoped=true&"
import script from "./Promotions.vue?vue&type=script&lang=ts&"
export * from "./Promotions.vue?vue&type=script&lang=ts&"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=1b37dc78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b37dc78",
  null
  
)

export default component.exports